import { useEffect } from "react"

import ReactGA from "react-ga4"
import { useLocation } from "react-router-dom"
import { useRecoilValue } from "recoil"

import { phaseState } from "~/containers/LegacyDesigner/state/phase"
import { proposalSectionTitleState } from "~/containers/Proposal/Brochure/utils/useSlideTitle"

import EnvVars from "../env-vars"

const getTrackingId = () => {
  switch (EnvVars.NODE_ENV) {
    case `production`:
      return `G-15JN4H0PEB`
    case `qa`:
      return `G-KF734T2G5W`
    case `development`:
      return `G-0MFH48B64Q`
    case `staging`:
      return `G-73H5XVTHZ0`
    default:
      return `NODE_ENV not set`
  }
}

export const useGoogleAnalytics: VoidFunction = () => {
  const location = useLocation()
  useEffect(() => {
    const trackingId = getTrackingId()
    ReactGA.initialize(trackingId)
  }, [])
  useEffect(() => {
    const analyticsData = {
      hitType: `pageview`,
      page: location.pathname,
    }
    ReactGA.send(analyticsData)
  }, [location])
}
